<template>
    <div class="original-currency-notification text-caption">
        <v-divider class="my-4" />
        <i>{{ $t('original_currency_notification', {currency}) }}</i>
        <i>{{
            $t('original_currency_amount_notification', {
                currency: originalCurrency,
                price: $filters.priceFormat(originalAmount, originalCurrency),
            })
        }}</i>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class OriginalCurrencyNotification extends Vue {
        @Prop({required: true}) price

        get currency() {
            return persistentStore.currency
        }

        get originalCurrency() {
            return this.price.originalCurrency || this.price.currency
        }

        get originalAmount() {
            return this.price.originalAmount || this.price.amount
        }
    }

    export default OriginalCurrencyNotification
</script>
